export default __webpack_public_path__ + "static/ingress-1-4ddbda583d2711fcd1180f0c698c3c12.png";